var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 356,
    viewBox: "0 0 277 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_1510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.414 0H65.487C29.716 0 0 31.595 0 67.365V216.293C0 251.994 29.716 281.57 65.486 281.57H97.637L114.27 310.59L139.949 355.547L165.629 310.799L182.262 281.57H214.413C250.113 281.57 276.142 251.994 276.142 216.293V67.365C276.142 31.595 250.114 0 214.414 0Z",
    fill: "#131312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.439 210.6C109.372 210.6 106.839 209.867 104.839 208.4C102.839 206.933 101.639 205 101.239 202.6C100.839 200.067 101.439 197.267 103.039 194.2L163.439 80.6V89.4H98.6391C95.0391 89.4 92.2391 88.4667 90.2391 86.6C88.3724 84.7333 87.4391 82.1333 87.4391 78.8C87.4391 75.3333 88.3724 72.6667 90.2391 70.8C92.2391 68.9333 95.0391 68 98.6391 68H176.039C179.639 68 182.572 68.9333 184.839 70.8C187.106 72.6667 188.239 75.3333 188.239 78.8C188.239 81.7333 187.839 84.3333 187.039 86.6C186.239 88.7333 185.172 91.0667 183.839 93.6L127.039 202.2C125.572 205.133 123.639 207.267 121.239 208.6C118.972 209.933 116.039 210.6 112.439 210.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_1510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276.196,
    height: 355.547,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop7);
export default __webpack_public_path__ + "static/media/stop7.58a0a4d1f1f74dc42abdc0ba87f7d5ca.svg";
export { ForwardRef as ReactComponent };